.keyword {
  margin-top: 45px;
}

.keywordTitle {
  margin-bottom: 8px;
  font-size: var(--font-size-sm);
  font-weight: bold;
  line-height: 1.6;
}

.keywordList {
  display: flex;
  flex-wrap: wrap;
}

.keywordItem {
  padding: 6px;
  margin: 0 8px 8px 0;
  font-size: var(--font-size-sm);
  color: #797979;
  white-space: nowrap;
  background-color: var(--color-white);
  border-radius: 6px;
}
